import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { alpha, Box, Container, IconButton, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMicrospecThemeLanguageContext } from '../../../../MicrospecDynamicUI/Themes';
import UpsertSpecification from './UpsertSpecification';

const AddSpecification: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { translate } = useMicrospecThemeLanguageContext().localizationProvider;
  const handleCancel = () => navigate('/manager/specifications/manage');

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton onClick={handleCancel} sx={{ backgroundColor: alpha(theme.palette.primary.main, 0.1), '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.2) } }}>
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900] }}>
            {translate('specification.addTitle')}
          </Typography>
          <Typography variant="body2" color="text.secondary">{translate('specification.createDescription')}</Typography>
        </Box>
      </Box>
      <UpsertSpecification
        specificationId={undefined}
        onSave={() => { setTimeout(() => { window.location.href = '/manager/specifications/manage'; }, 2000); }}
        onCancel={handleCancel}
      />
    </Container>
  );
};

export default AddSpecification;
